module.exports =
{
    //'API_URL': 'http://localhost:8000/api',
    //'API_URL': 'https://dev.alxgrn.ru/api',
    'API_URL': 'https://retailconnect.ru/api',
}
